export default {"src":"/_next/static/media/Step1.c2be502e.svg","height":254,"width":605,"blurWidth":0,"blurHeight":0};